import Axios from "axios";
export async function createCheckoutSession(email) {
  const configAPi = {
    headers: {
      "Content-Type": "application/json",
      ServiceToken: process.env.REACT_APP_SERVICE_TOKEN,
    },
  };

  try {
    const productId = process.env.REACT_APP_YEARLY_PRICE_ID;
    const successUrl = process.env.REACT_APP_CHECKOUT_SUCCESS_URL;
    const failureURL = process.env.REACT_APP_CHECKOUT_FAILURE_URL;

    const r = await Axios.post(
      `${process.env.REACT_APP_PAYMENT_SERVICES_URL}/api/6.0/stripe/create-session-checkout`,

      { email, productId, successUrl, failureURL },
      configAPi
    );
    return r.data;
  } catch (err) {
    throw err;
  }
}
